import { sessaoFetchLoading, sessaoFetch } from '@/service/fetch'
import { serialize } from '@/service/util'

export async function get (id) {
  return sessaoFetchLoading(`base`, `/unidade/${id}`)
}
export async function getUnidades (dados) {
  return sessaoFetchLoading(`base`, `/unidade?` + serialize(dados), 'GET')
}
export async function getUnidadesUsuarios (dados) {
  return sessaoFetchLoading(`base`, `/unidadeusuarios?` + serialize(dados), 'GET')
}
export async function getUnidadesAssinaturas (dados) {
  return sessaoFetchLoading(`consig`, `/unidades/Assinaturas?` + serialize(dados), 'GET')
}
export async function getUnidadesSelect (dados) {
  return sessaoFetchLoading(`base`, `/unidade?all=1&` + serialize(dados))
}
export async function add (dados) {
  return sessaoFetchLoading(`consig`, `/unidades/NovaUnidade`, 'POST', dados)
}
export async function edit (dados) {
  return sessaoFetchLoading(`base`, `/unidade/${dados.id}`, 'PUT', dados)
}
export async function editLimite (dados) {
  return sessaoFetchLoading(`consig`, `/unidades/AlterarLimiteunidade?unidadeId=${dados.id}&novaQuantidadeUsuario=${dados.maxusuarios}`, 'PUT')
}
export async function delUnidade (dados) {
  return sessaoFetchLoading(`base`, `/unidade/${dados}`, 'DELETE')
}
export async function delUnidadeMaster (dados) {
  return sessaoFetchLoading(`base`, `/unidade/${dados}/master`, 'DELETE')
}
export async function pacotes (dados) {
  let created = ''
  if (dados) {
    if (dados.data_inicial && dados.data_final) {
      created = '&createdAt=' + dados.data_inicial + '&createdAt=' + dados.data_final
    } else if (dados.data_inicial && !dados.data_final) {
      created = '&createdAt=' + dados.data_inicial + '&createdAt='
    } else if (!dados.data_inicial && dados.data_final) {
      created = '&createdAt=&createdAt=' + dados.data_final
    }
  }
  let dadosserial = serialize(dados) + created
  return sessaoFetchLoading(`base`, `/unidade/pacote?` + dadosserial, 'GET')
}
export async function addPacote (dados) {
  return sessaoFetchLoading(`base`, `/unidade/pacote`, 'POST', dados)
}
export async function inativaPacote (id) {
  return sessaoFetchLoading(`base`, `/unidade/pacote/${id}/inativar`, 'GET')
}
export async function listUnidadesAcesso () {
  return sessaoFetchLoading(`base`, `/unidade/list/acesso`, 'GET')
}
export async function getUnidadeFoco () {
  return sessaoFetchLoading(`base`, `/unidade/usuario/foco`, 'GET')
}
export async function getUnidadesTotalUsuarios (payload) {
  return sessaoFetchLoading(`consig`, `/unidades/UnidadesComUsuariosAtivos?${serialize(payload)}`, 'GET')
}
export async function getUnidadesTotalUsuariosPorVendedor (payload) {
  return sessaoFetchLoading(`consig`, `/unidades/UnidadesComUsuariosAtivosPorVendedor?${serialize(payload)}`, 'GET')
}
export async function alteraStatusUnidade (dados) {
  return sessaoFetchLoading(`consig`, `/unidades/AlteraStatusUnidade`, 'PUT', dados)
}
export async function getUnidadesRelatorioSelect (dados) {
  return sessaoFetchLoading(`base`, `/unidadesrelatorio?all=1&` + serialize(dados))
}
export async function getAssinatura (id) {
  return sessaoFetchLoading(`consig`, `/unidades/${id}/assinatura`)
}
export async function saveAssinatura (dados) {
  return sessaoFetchLoading(`consig`, `/unidades/assinatura`, 'POST', dados)
}
export async function getCalculaPlano (dados) {
  return sessaoFetch(`consig`, `/planos_assinaturas/CalcularValorContratado?` + serialize(dados), 'GET')
}
export async function getcalculaUsuariosAdicionais (dados) {
  return sessaoFetch(`consig`, `/planos_assinaturas/CalcularValorUsuariosAdicionais?` + serialize(dados), 'GET')
}
export async function getcalculaUsuariosAdicionaisPlanoControle (dados) {
  return sessaoFetch(`consig`, `/planos_controle/CalcularValorUsuariosAdicionais?` + serialize(dados), 'GET')
}
export async function geraFaturaUsuarios (dados) {
  return sessaoFetchLoading(`consig`, `/assinaturas/GerarFaturaUsuariosAdicionais`, 'POST', dados)
}
export async function geraFaturaUsuariosPlanoControle (dados) {
  return sessaoFetchLoading(`consig`, `/assinaturas/GerarFaturaUsuariosAdicionaisPlanoControle`, 'POST', dados)
}
export async function geraFaturaAvulsa (dados) {
  return sessaoFetchLoading(`consig`, `/assinaturas/GerarFaturaAvulsa`, 'POST', dados)
}
export async function cancelaAssinatura (id) {
  return sessaoFetchLoading(`consig`, `/unidades/${id}/assinatura`, 'DELETE')
}
export async function ativarAssinaturaComprovante (id) {
  return sessaoFetchLoading(`consig`, `/unidades/${id}/AtivarAssinaturaPorComprovante`, 'POST', id)
}
export async function saveAssinaturaControle (dados) {
  return sessaoFetchLoading('consig', '/unidades/assinatura_controle', 'POST', dados)
}
export async function saveAssinaturaTeste (dados) {
  return sessaoFetchLoading(`consig`, `/unidades/assinatura_teste`, 'POST', dados)
}



// WEBPACK FOOTER //
// ./src/api/unidade.js